/* ==========================================================================
   ECOMATELAS — MOTION.JS
   Utilitaire global d'animations d'apparition / disparition.
   À charger une fois dans theme.liquid :
   <script src="{{ 'mm-motion.js' | asset_url }}" defer></script>
   --------------------------------------------------------------------------
   1) Apparition au scroll :
      <div data-mm-reveal>…</div>            → slide-up spring
      <div data-mm-reveal="pop">…</div>      → pop scale spring
      <div data-mm-reveal="left">…</div>     → glisse depuis la droite
      Stagger automatique des enfants :
      <ul data-mm-stagger="90">              → 90ms entre chaque enfant
        <li data-mm-reveal>…</li>
   2) API JS :
      MmMotion.reveal(el)                    → rejoue l'apparition
      MmMotion.hide(el, done)                → disparition (fade + shrink)
      MmMotion.pop(el)                       → micro pop (ajout panier, check…)
      MmMotion.dragScroll(track, opts)       → drag premium pour sliders
   ========================================================================== */
   (function () {
	'use strict';
  
	function initStagger(root) {
	  root.querySelectorAll('[data-mm-stagger]').forEach(function (parent) {
		var step = parseInt(parent.getAttribute('data-mm-stagger'), 10) || 80;
		var i = 0;
		Array.prototype.forEach.call(parent.children, function (child) {
		  if (child.hasAttribute('data-mm-reveal')) {
			child.style.setProperty('--mm-delay', (i * step) / 1000 + 's');
			i++;
		  }
		});
	  });
	}
  
	/* Une fois l'apparition jouée, on retire l'attribut (et son delay) :
	   la transition d'entrée disparaît — aucun conflit possible avec un
	   hover ou un drag. La classe mm-in reste : les états qui en dépendent
	   (badges, flags…) restent visibles. */
	function cleanupReveal(el) {
	  el.removeAttribute('data-mm-reveal');
	  el.style.removeProperty('--mm-delay');
	}
  
	function scheduleCleanup(el) {
	  var done = false;
	  function finish() {
		if (done) return;
		done = true;
		el.removeEventListener('transitionend', onEnd);
		cleanupReveal(el);
	  }
	  function onEnd(e) {
		if (e.target === el && e.propertyName === 'transform') finish();
	  }
	  el.addEventListener('transitionend', onEnd);
	  window.setTimeout(finish, 1600); /* filet de sécurité (delay + durée max) */
	}
  
	function ownImage(el) {
	  if (el.tagName === 'IMG') return el;
	  var imgs = el.querySelectorAll('img');
	  for (var i = 0; i < imgs.length; i++) {
		var node = imgs[i].parentElement;
		var nested = false;
		while (node && node !== el) {
		  if (node.hasAttribute('data-mm-reveal')) { nested = true; break; }
		  node = node.parentElement;
		}
		if (!nested) return imgs[i];
	  }
	  return null;
	}

	function revealWhenReady(el) {
	  var img = ownImage(el);
	  if (!img || img.complete) {
		el.classList.add('mm-in');
		scheduleCleanup(el);
		return;
	  }
	  var done = false;
	  function finish() {
		if (done) return;
		done = true;
		img.removeEventListener('load', finish);
		img.removeEventListener('error', finish);
		el.classList.add('mm-in');
		scheduleCleanup(el);
	  }
	  img.addEventListener('load', finish);
	  img.addEventListener('error', finish);
	  window.setTimeout(finish, 8000); /* filet de sécurité si l'image ne charge jamais (pas un délai normal : une image lente doit avoir le temps de finir) */
	}

	var io = null;
	function observer() {
	  if (io) return io;
	  io = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
		  if (entry.isIntersecting) {
			revealWhenReady(entry.target);
			io.unobserve(entry.target);
		  }
		});
	  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
	  return io;
	}
  
	function scan(root) {
	  initStagger(root);
	  root.querySelectorAll('[data-mm-reveal]:not(.mm-in)').forEach(function (el) {
		observer().observe(el);
	  });
	}
  
	window.MmMotion = {
	  scan: scan,
  
	  /* Rejoue l'apparition d'un élément (ou d'un bloc entier) */
	  reveal: function (el) {
		el.classList.remove('mm-in');
		void el.offsetWidth; /* force reflow */
		el.classList.add('mm-in');
	  },
  
	  /* Disparition douce puis callback (retrait DOM, etc.) */
	  hide: function (el, done) {
		el.style.transition =
		  'opacity .28s var(--mm-curve-out), transform .28s var(--mm-curve-out)';
		el.style.opacity = '0';
		el.style.transform = 'scale(.92) translateY(8px)';
		window.setTimeout(function () { if (done) done(el); }, 300);
	  },
  
	  /* Micro-rebond delightful : confirmation d'action */
	  pop: function (el) {
		el.animate(
		  [
			{ transform: 'scale(1)' },
			{ transform: 'scale(1.18)', offset: 0.35 },
			{ transform: 'scale(0.95)', offset: 0.7 },
			{ transform: 'scale(1)' }
		  ],
		  { duration: 420, easing: 'cubic-bezier(.34,1.56,.64,1)' }
		);
	  },
  
	  /* ---- Ressort ÉLASTIQUE partagé ---------------------------------------
		 Le « elastic.out » des prototypes de Killian : la cible est dépassée
		 puis rejointe en quelques oscillations amorties. On ne peut pas
		 l'écrire en CSS — WAAPI et les transitions n'interpolent qu'avec des
		 béziers, et une bézier est monotone : elle peut dépasser UNE fois
		 (curve-big) mais jamais osciller. La courbe est donc calculée ici et
		 ÉCHANTILLONNÉE en keyframes, l'easing restant 'linear'.
  
		 elasticFrom(el, { x, y, rotate, unit, duration, delay, fade })
		 part de l'écart demandé et revient à l'état neutre. L'opacité, elle,
		 ne suit PAS le ressort : elle monterait au-dessus de 1 puis
		 redescendrait — un clignotement. Elle prend le premier tiers.
		 Renvoie l'Animation, pour pouvoir l'annuler. */
	  elasticFrom: function (el, opts) {
		var o = opts || {};
		var unit = o.unit || 'px';
		var x = o.x || 0, y = o.y || 0, rot = o.rotate || 0;
		var steps = o.steps || 26;
		var amp = o.amplitude || 1, per = o.period || 0.6;
		var frames = [];
		for (var i = 0; i <= steps; i++) {
		  var t = i / steps;
		  /* easeOutElastic (Penner) : 1 au repos, oscille autour de 1 */
		  var e = (t <= 0) ? 0 : (t >= 1) ? 1
			: amp * Math.pow(2, -10 * t) *
			  Math.sin((t - per / (2 * Math.PI) * Math.asin(1 / Math.max(amp, 1))) *
					   (2 * Math.PI) / per) + 1;
		  var reste = 1 - e; /* part de l'écart encore à parcourir */
		  var f = {
			offset: t,
			transform: 'translate(' + (x * reste) + unit + ',' + (y * reste) + unit +
			  ') rotate(' + (rot * reste) + 'deg)'
		  };
		  /* fadeStart retarde le fondu : tant que l'élément est LOIN de sa place
			 il doit rester invisible, sinon on le voit se faire trancher par le
			 bord de l'écran en chemin. Le ressort couvre l'essentiel du trajet
			 dans les premiers dixièmes, donc un retard court suffit. */
		  if (o.fade) {
			f.opacity = String(Math.max(0, Math.min(1, (t - (o.fadeStart || 0)) / 0.3)));
		  }
		  frames.push(f);
		}
		return el.animate(frames, {
		  duration: o.duration || 1100,
		  delay: o.delay || 0,
		  easing: 'linear',
		  /* 'backwards' seulement : à la fin l'élément DOIT retomber sur son
			 CSS (transform neutre, et l'inclinaison de repos de son parent),
			 sinon un transform inline figé mangerait les états de survol. */
		  fill: 'backwards'
		});
	  },
  
	  /* Glisse horizontale snappy vers une position (ease-out maison, rAF).
		 Plus vif et régulier que scrollTo({behavior:'smooth'}). Coupe le
		 scroll-snap pendant l'animation puis le restaure.
		 MmMotion.glideTo(track, targetScrollLeft) */
	  glideTo: function (track, target) {
		if (track._mmGlide) window.cancelAnimationFrame(track._mmGlide);
		var from = track.scrollLeft;
		var dist = target - from;
		if (Math.abs(dist) < 1) { track.scrollLeft = target; return; }
		var dur = Math.min(560, 300 + Math.abs(dist) * 0.22);
		var snap = track.style.scrollSnapType;
		track.style.scrollSnapType = 'none';
		var t0 = performance.now();
		function frame(now) {
		  var p = Math.min((now - t0) / dur, 1);
		  var e = 1 - Math.pow(1 - p, 3);
		  track.scrollLeft = from + dist * e;
		  if (p < 1) { track._mmGlide = window.requestAnimationFrame(frame); }
		  else { track._mmGlide = null; track.style.scrollSnapType = snap; }
		}
		track._mmGlide = window.requestAnimationFrame(frame);
	  },
  
	  /* ------------------------------------------------------------------
		 Drag-to-scroll premium pour les sliders à scroll-snap.
		 MmMotion.dragScroll(track, { align: 'start'|'center', enabled: fn })
  
		 - suivi AMORTI : la piste suit le curseur avec une inertie douce,
		   recalculée à chaque frame (rAF continu) — soyeux quel que soit
		   le taux d'événements de la souris
		 - relâchement STEP BY STEP : un petit drag ou un flick passe à la
		   carte suivante/précédente, sinon retour à la carte de départ ;
		   la glisse est une animation maison (ease-out), 100% contrôlée
		 - le scroll-snap natif est coupé en inline pendant toute la
		   séquence et restauré une fois posé pile sur la cible
		 - pointer capture = hover figé pendant le geste, zéro conflit
		 ------------------------------------------------------------------ */
	  dragScroll: function (track, opts) {
		opts = opts || {};
		var align = opts.align || 'start';
		var isDown = false, moved = false, startX = 0, startScroll = 0, pid = null;
		var desired = 0, pos = 0, followId = null, glideId = null;
		var lastX = 0, lastT = 0, vel = 0;
		var startIndex = 0;
  
		/* offsetLeft relatif à la piste : cibles calculées sur le layout pur,
		   insensibles aux transforms d'animations en cours */
		if (getComputedStyle(track).position === 'static') {
		  track.style.position = 'relative';
		}
  
		/* positions d'ancrage de chaque carte, bornées au scroll possible */
		function targets() {
		  var padLeft = parseFloat(getComputedStyle(track).paddingLeft) || 0;
		  var max = track.scrollWidth - track.clientWidth;
		  var list = [];
		  Array.prototype.forEach.call(track.children, function (el) {
			if (!el.offsetWidth) return;
			var t = align === 'center'
			  ? el.offsetLeft + el.offsetWidth / 2 - track.clientWidth / 2
			  : el.offsetLeft - padLeft;
			list.push(Math.min(Math.max(t, 0), max));
		  });
		  return list;
		}
		function nearestIndex(list, x) {
		  var best = 0;
		  list.forEach(function (t, i) {
			if (Math.abs(t - x) < Math.abs(list[best] - x)) best = i;
		  });
		  return best;
		}
  
		function stopFollow() {
		  if (followId) { window.cancelAnimationFrame(followId); followId = null; }
		}
		function stopGlide() {
		  if (glideId) { window.cancelAnimationFrame(glideId); glideId = null; }
		}
		function restoreSnap() { track.style.scrollSnapType = ''; }
  
		/* suivi amorti du curseur, une écriture par frame */
		function follow() {
		  followId = null;
		  pos += (desired - pos) * 0.3;
		  if (Math.abs(desired - pos) < 0.5) pos = desired;
		  track.scrollLeft = pos;
		  if (isDown || Math.abs(desired - pos) >= 0.5) {
			followId = window.requestAnimationFrame(follow);
		  }
		}
  
		/* glisse maison vers la cible : durée proportionnelle, ease-out —
		   même sensation que les flèches, terminaison exacte garantie */
		function glideTo(target) {
		  stopGlide();
		  var from = track.scrollLeft;
		  var dist = target - from;
		  if (Math.abs(dist) < 1) {
			track.scrollLeft = target;
			restoreSnap();
			return;
		  }
		  var dur = Math.min(650, 340 + Math.abs(dist) * 0.25);
		  var t0 = performance.now();
		  function frame(now) {
			var p = Math.min((now - t0) / dur, 1);
			var e = 1 - Math.pow(1 - p, 3);
			track.scrollLeft = from + dist * e;
			if (p < 1) {
			  glideId = window.requestAnimationFrame(frame);
			} else {
			  glideId = null;
			  restoreSnap();
			}
		  }
		  glideId = window.requestAnimationFrame(frame);
		}
  
		/* Une piste en user-select:none n'empêche PAS le navigateur de démarrer
		   une sélection quand le curseur SORT de la piste en cours de geste : il
		   l'ancre sur le premier contenu sélectionnable rencontré à côté (le
		   titre de la section…) et la peint sur tout ce que la plage traverse,
		   cartes comprises. On coupe donc selectstart le temps du geste — et
		   seulement le temps du geste, pour ne pas rendre la page insélectionnable. */
		function refuseSelection(e) { e.preventDefault(); }
  
		track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  
		track.addEventListener('pointerdown', function (e) {
		  if (e.pointerType !== 'mouse') return;
		  if (opts.enabled && !opts.enabled()) return;
		  stopGlide();
		  stopFollow();
		  track.style.scrollSnapType = 'none';
		  /* stoppe net une glisse smooth native en cours (flèches) */
		  track.scrollTo({ left: track.scrollLeft, behavior: 'auto' });
		  isDown = true; moved = false;
		  document.addEventListener('selectstart', refuseSelection);
		  pid = e.pointerId;
		  startX = lastX = e.clientX;
		  lastT = performance.now();
		  vel = 0;
		  startScroll = desired = pos = track.scrollLeft;
		  startIndex = nearestIndex(targets(), startScroll);
		});
  
		window.addEventListener('pointermove', function (e) {
		  if (!isDown) return;
		  var dx = e.clientX - startX;
		  if (!moved && Math.abs(dx) > 6) {
			moved = true;
			/* gel des animations + hover figé, seulement pendant le geste */
			track.classList.add('is-dragging');
			/* une sélection a pu naître avant le seuil des 6px : on l'efface une
			   fois, au moment où le geste devient un drag */
			var sel = window.getSelection();
			if (sel && !sel.isCollapsed) sel.removeAllRanges();
			try { track.setPointerCapture(pid); } catch (err) {}
		  }
		  if (moved) {
			desired = startScroll - dx;
			var now = performance.now();
			var dt = now - lastT;
			if (dt > 0) {
			  vel = 0.8 * vel + 0.2 * ((e.clientX - lastX) / dt);
			  lastX = e.clientX;
			  lastT = now;
			}
			if (!followId) followId = window.requestAnimationFrame(follow);
		  }
		});
  
		function endDrag() {
		  if (!isDown) return;
		  isDown = false;
		  document.removeEventListener('selectstart', refuseSelection);
		  stopFollow();
		  track.classList.remove('is-dragging');
		  if (!moved) { restoreSnap(); return; }
  
		  var list = targets();
		  if (!list.length) { restoreSnap(); return; }
  
		  var current = track.scrollLeft;
		  var index = nearestIndex(list, current);
  
		  /* step by step : si on est resté sur la carte de départ, un drag
			 franc ou un flick suffit pour passer à la suivante/précédente */
		  if (index === startIndex && list.length > 1) {
			var delta = current - startScroll;   /* >0 : on avance */
			var flick = -vel;                    /* flick vers la gauche = avancer */
			var next = Math.min(startIndex + 1, list.length - 1);
			var prev = Math.max(startIndex - 1, 0);
			var stepSize = Math.max(
			  Math.abs(list[next] - list[startIndex]),
			  Math.abs(list[startIndex] - list[prev]),
			  1
			);
			if (delta > stepSize * 0.12 || flick > 0.35) index = next;
			else if (delta < -stepSize * 0.12 || flick < -0.35) index = prev;
		  }
  
		  glideTo(list[index]);
		}
		window.addEventListener('pointerup', endDrag);
		window.addEventListener('pointercancel', endDrag);
  
		/* pas de clic parasite après un drag */
		track.addEventListener('click', function (e) {
		  if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
		}, true);
	  }
	};
  
	/* ------------------------------------------------------------------
	   ENFONCEMENT DES BOUTONS — tenu à l'appui, ressort au relâchement.
  
	   Le même geste que les flèches de slider, demandé pour les CTA. Il vit
	   ICI, dans le runtime déjà chargé partout, et non dans un script propre au
	   Bouton : les boutons sont sur toutes les pages, leur ajouter une
	   dépendance pour une animation n'aurait pas été un bon échange.
  
	   Pourquoi du JS pour ça. Le CSS tient très bien l'ENFONCEMENT — :active est
	   un état. Ce qu'il ne sait pas faire, c'est distinguer les deux chemins qui
	   mènent au même état d'arrivée : après un relâchement on veut un ressort
	   lent (650ms), après une simple entrée de souris un survol vif (380ms). Or
	   les deux atterrissent sur .mm-btn:hover, et une transition ne connaît que
	   son point d'arrivée. D'où le ressort joué à la main, seulement au
	   relâchement.
  
	   La cible du ressort n'est pas toujours 1 : si le pointeur est resté sur le
	   bouton, il revient à l'échelle de SURVOL. On la relit au moment du
	   relâchement — sans quoi la fin d'animation ferait un saut vers l'état CSS.
  
	   Rien ici pour prefers-reduced-motion : la garde est déjà posée plus haut
	   pour tout le module. */
	var BTN_SEL = '.mm-btn[data-btn-animation="true"]:not([disabled])';
  
	function btnJeton(el, nom, repli) {
	  var v = getComputedStyle(el).getPropertyValue(nom).trim();
	  return v || repli;
	}
	function btnMs(v, repli) {
	  var n = parseFloat(v);
	  if (!isFinite(n)) return repli;
	  return (v.indexOf('ms') === -1 && v.indexOf('s') !== -1) ? n * 1000 : n;
	}
	function btnEchelle(el, nom, repli) {
	  var n = parseFloat(btnJeton(el, nom, ''));
	  return isFinite(n) ? n : repli;
	}
  
	function btnEnfoncer(el) {
	  if (el.__mmBtnSpring) { el.__mmBtnSpring.cancel(); el.__mmBtnSpring = null; }
	  el.classList.add('is-pressed');
	}
  
	function btnRelacher(el) {
	  if (!el.classList.contains('is-pressed')) return;
	  el.classList.remove('is-pressed');
	  if (!el.animate) return;
	  /* Ressort ADDITIF, et c'est tout l'enjeu. Un ressort qui VISE une échelle
		 fixe doit choisir sa cible au départ : l'échelle de survol si le doigt
		 est encore là, 1 sinon. Mais l'état peut changer PENDANT les 650ms — on
		 quitte le bouton en cours de route — et l'animation, prioritaire sur le
		 CSS, maintient alors sa cible périmée puis la lâche d'un coup à la fin.
		 C'est le à-coup signalé par Killian.
		 En additif, l'animation ne vise plus rien : elle n'est qu'un
		 MULTIPLICATEUR qui s'éteint (elle finit à scale(1), l'identité). L'état
		 de repos reste au CSS et peut bouger librement sous elle — perdre le
		 survol devient une transition douce de plus, composée avec le ressort au
		 lieu de le contredire. Et à la fin, plus rien à rendre : aucun saut.
		 Effet de bord heureux : le quick-add des cartes produit, à scale(0) tant
		 que la carte n'est pas survolée, reste invisible — 0 multiplié par
		 n'importe quoi vaut 0. Le garde-fou qu'il avait fallu poser n'a plus
		 lieu d'être. */
	  var presse = btnEchelle(el, '--mm-btn-press', 0.96);
	  var socle = (el.matches(':hover') || el.matches(':focus-visible'))
		? btnEchelle(el, '--mm-btn-hover', 1.05)
		: 1;
	  /* la contribution qui, multipliée par le socle, redonne l'échelle enfoncée */
	  var depart = socle ? presse / socle : presse;
	  var anim = el.animate(
		[{ transform: 'scale(' + depart + ')' }, { transform: 'scale(1)' }],
		{
		  duration: btnMs(btnJeton(el, '--mm-duration-slow', '650ms'), 650),
		  easing: btnJeton(el, '--mm-curve-big', 'cubic-bezier(0.30, 1.90, 0.44, 1)'),
		  composite: 'add'
		}
	  );
	  el.__mmBtnSpring = anim;
	  anim.addEventListener('finish', function () { if (el.__mmBtnSpring === anim) el.__mmBtnSpring = null; });
	}
  
	function btnCible(t) { return t && t.closest ? t.closest(BTN_SEL) : null; }
  
	/* ---- Enfoncement GÉNÉRIQUE, opt-in par data-mm-press --------------------
	   Pour tout ce dont le repos ou le survol porte DÉJÀ un transform. Les
	   cartes se soulèvent au survol (translateY(-4px)) : un enfoncement écrit en
	   CSS REMPLACERAIT ce translate au lieu de s'y ajouter — c'est ce que
	   faisait .mm-bcard:active, qui faisait retomber la carte à plat au moment
	   même où on la pressait. Ici l'enfoncement est une animation ADDITIVE
	   TENUE (fill: forwards) : elle se compose avec la levée, quelle qu'elle
	   soit, et le relâchement enchaîne sur le même ressort additif que les
	   boutons.
	   Les boutons, eux, gardent leur classe CSS : leur transform est une pure
	   échelle, le CSS s'en sort très bien et ça leur laisse un repli sans
	   script. La différence est assumée, pas accidentelle. */
	function pressEchelle(el) {
	  var n = parseFloat(btnJeton(el, '--mm-press', ''));
	  return isFinite(n) ? n : 0.98;
	}
  
	function pressEnfoncer(el) {
	  if (!el.animate) return;
	  if (el.__mmPressUp) { el.__mmPressUp.cancel(); el.__mmPressUp = null; }
	  if (el.__mmPressDown) return;
	  el.__mmPressDown = el.animate(
		[{ transform: 'scale(1)' }, { transform: 'scale(' + pressEchelle(el) + ')' }],
		{
		  duration: btnMs(btnJeton(el, '--mm-duration-fast', '180ms'), 180),
		  easing: btnJeton(el, '--mm-curve-out', 'cubic-bezier(0.22, 1, 0.36, 1)'),
		  fill: 'forwards',
		  composite: 'add'
		}
	  );
	}
  
	function pressRelacher(el) {
	  var down = el.__mmPressDown;
	  if (!down) return;
	  el.__mmPressDown = null;
	  down.cancel();
	  var anim = el.animate(
		[{ transform: 'scale(' + pressEchelle(el) + ')' }, { transform: 'scale(1)' }],
		{
		  duration: btnMs(btnJeton(el, '--mm-duration-slow', '650ms'), 650),
		  easing: btnJeton(el, '--mm-curve-big', 'cubic-bezier(0.30, 1.90, 0.44, 1)'),
		  composite: 'add'
		}
	  );
	  el.__mmPressUp = anim;
	  anim.addEventListener('finish', function () { if (el.__mmPressUp === anim) el.__mmPressUp = null; });
	}
  
	function pressCible(t) { return t && t.closest ? t.closest('[data-mm-press]') : null; }
  
	document.addEventListener('pointerdown', function (e) {
	  var c = pressCible(e.target);
	  if (c) pressEnfoncer(c);
	});
	['pointerup', 'pointercancel'].forEach(function (type) {
	  document.addEventListener(type, function (e) {
		var c = pressCible(e.target);
		if (c) pressRelacher(c);
		else document.querySelectorAll('[data-mm-press]').forEach(pressRelacher);
	  });
	});
	document.addEventListener('pointerout', function (e) {
	  var c = pressCible(e.target);
	  if (c && !c.contains(e.relatedTarget)) pressRelacher(c);
	});
	document.addEventListener('keydown', function (e) {
	  if (e.key !== 'Enter' && e.key !== ' ') return;
	  var c = pressCible(e.target);
	  if (c) pressEnfoncer(c);
	});
	document.addEventListener('keyup', function (e) {
	  if (e.key !== 'Enter' && e.key !== ' ') return;
	  var c = pressCible(e.target);
	  if (c) pressRelacher(c);
	});
  
	document.addEventListener('pointerdown', function (e) {
	  var b = btnCible(e.target);
	  if (b) btnEnfoncer(b);
	});
	['pointerup', 'pointercancel'].forEach(function (type) {
	  document.addEventListener(type, function (e) {
		var b = btnCible(e.target);
		if (b) btnRelacher(b);
		/* relâché ailleurs : aucun bouton ne doit rester écrasé */
		else document.querySelectorAll('.mm-btn.is-pressed').forEach(btnRelacher);
	  });
	});
	document.addEventListener('pointerout', function (e) {
	  var b = btnCible(e.target);
	  if (b) btnRelacher(b);
	});
	document.addEventListener('keydown', function (e) {
	  if (e.key !== 'Enter' && e.key !== ' ') return;
	  var b = btnCible(e.target);
	  if (b) btnEnfoncer(b);
	});
	document.addEventListener('keyup', function (e) {
	  if (e.key !== 'Enter' && e.key !== ' ') return;
	  var b = btnCible(e.target);
	  if (b) btnRelacher(b);
	});
  
  
	/* ------------------------------------------------------------------
	   Autoplay fiable sur Safari : l'attribut `muted` n'est pas toujours pris
	   en compte pour la décision d'autoplay → on force la PROPRIÉTÉ muted +
	   playsinline puis on appelle play(). Retry au 1er geste (Low Power Mode). */
	function bootVideos(root) {
	  (root || document).querySelectorAll('video[autoplay]').forEach(function (v) {
		v.muted = true;
		v.defaultMuted = true;
		v.setAttribute('muted', '');
		v.playsInline = true;
		v.setAttribute('playsinline', '');
		var p = v.play();
		if (p && p.catch) p.catch(function () {});
	  });
	}
	window.MmMotion.bootVideos = bootVideos;
  
	function kickVideos() {
	  document.querySelectorAll('video[autoplay]').forEach(function (v) {
		if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
	  });
	}
	window.addEventListener('pointerdown', kickVideos, { once: true, passive: true });
	window.addEventListener('touchstart', kickVideos, { once: true, passive: true });
  
	function boot() { scan(document); bootVideos(document); }
	if (document.readyState === 'loading') {
	  document.addEventListener('DOMContentLoaded', boot);
	} else {
	  boot();
	}

	document.addEventListener('shopify:section:load', function (e) {
	  scan(e.target);
	  bootVideos(e.target);
	});
  })();